import { api } from "../client";

export const get8x8 = () => {
  return api.get(`/readytowork/eightbyeight`);
};
